import { ONE_MINUTE } from '@lumapps/utils/time/constants';

export const CONCURRENT_ACCESS_SCOPE = 'concurrent-access';

export const CONCURRENT_ACCESS_FEATURE_TOKEN = 'content-edit-concurrent-access';

/** Time in millisecond until the content lease is considered stale. (default: 30s) */
export const CONTENT_LEASE_STALE_TIME = ONE_MINUTE / 2;

/** Interval in millisecond until the content lease should be fetched again. (default: 60s) */
export const CONTENT_LEASE_REFETCH_INTERVAL = ONE_MINUTE;
